// extracted by mini-css-extract-plugin
export default {"titleButton":"EditNodeLink_titleButton__9G6-N","ellipsisify":"EditNodeLink_ellipsisify__6nyT2"};